// extracted by mini-css-extract-plugin
export var banner = "_ng-0";
export var settingRow = "_ng-2";
export var titleIcon = "_ng-1";